/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {CommandMap, CommandsDescriptor} from '@app/models/commands/commands-descriptor';
import {MessageRecord} from '@app/services/data.service';
import {BlackboardService} from '@app/modules/blackboard/services/blackboard.service';
import {Store} from '@ngxs/store';
import {ExecBuffer} from '@app/models/exec-buffer';

export enum BlackboardEvents {
  DRAW = 'DRAW',
  TEXT = 'TEXT',
  CLEAR = 'CLEAR',
  POINTER_MOVE = 'POINTER_MOVE',
}

export enum BlackboardStates {
  TOGGLE_BOARD = 'TOGGLE_BOARD',
  TOGGLE_POINTER = 'TOGGLE_POINTER',
}


@Injectable({
  providedIn: 'root'
})
export class BlackboardCommands extends CommandsDescriptor<BlackboardEvents, BlackboardStates> {

  static category = 'BLACKBOARD';

  constructor(private blackboardService: BlackboardService, store: Store) {

    const MAP: CommandMap<BlackboardEvents, BlackboardStates> = {

      EVENT: {
        DRAW: (record: MessageRecord) => this.blackboardService.onDraw(record),
        TEXT: (record: MessageRecord) => this.blackboardService.onText(record),
        CLEAR: (record: MessageRecord) => this.blackboardService.onClear(record),
        POINTER_MOVE: (record: MessageRecord) => this.blackboardService.onPointerMove(record),
      },
      STATE: {
        TOGGLE_BOARD: (record: MessageRecord) => this.blackboardService.onToggleBoard(record),
        TOGGLE_POINTER: (record: MessageRecord) => this.blackboardService.onTogglePointer(record)
      }
    };
    super(MAP, new ExecBuffer(true), store);
    this.blackboardService.handleRecordStack = this.handleRecordStack.bind(this);
  }
}
